export function isInternalUsername(username: string): boolean {
    if (!username) {
        return false;
    }
    return username.includes('@feedonomics.com') || username === 'admin';
}
